import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Credenciales } from '../interfaces/credenciales';
import { ConfHttpService } from './conf-http.service';
@Injectable({
  providedIn: 'root'
})
export class LoginService {
  // endpopint = 'http://api.crabslogistica.dotsystems.com.ar/api/';
  // endpopint = 'http://localhost:8000/api/';
  endpopint = '';
  constructor(private http:HttpClient, conf:ConfHttpService) {
    this.endpopint=conf.getBackend();
   }

  iniciarSesion(credenciales:Credenciales)
  {
    const headers= new HttpHeaders({'Content-Type': 'application/json'});
    // console.log(credenciales);
  return this.http.post<any>(this.endpopint+'login',credenciales ,{headers: headers});

  }

  checkSesion(key:string)
  {
    // console.log(this.endpopint+'tokenVer/'+ key);
    return this.http.get<string>(this.endpopint+'tokenVer/'+ key).toPromise();

  }

}
